import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material';
import { ThemeContext } from './ThemeContext';
import lightTheme from './lightTheme';
import darkTheme from './darkTheme';
import AppThemeGlobalStyles from './AppThemeGlobalStyles';

export const CustomThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme : 'light';
  });

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
      localStorage.setItem('theme', 'dark');

    } else {
      setTheme('light');
      localStorage.setItem('theme', 'light');
    }
  };

  const muiTheme = theme === 'light' ? lightTheme : darkTheme;

  return (
    <ThemeContext.Provider value={{ theme: muiTheme, toggleTheme }}>
      <ThemeProvider theme={muiTheme}>
        <AppThemeGlobalStyles />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
